/* AE megamenu – openen/sluiten (hover, toetsenbord, touch), tabbladen en carrousels. Geen afhankelijkheden. */
(function () {
  'use strict';
  var CLOSE_DELAY = 120;

  /* Afbeeldingen in een paneel direct laden zodra iemand ernaar wijst (i.p.v. pas na openen) */
  function eager(el) {
    if (!el || el.__aeEager) return;
    el.__aeEager = true;
    el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  function initDesktop(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll(':scope > .ae-mm__item--panel'));
    var timer = null;
    var current = null;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var a = item.querySelector(':scope > .ae-mm__top');
      if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function open(item) {
      clearTimeout(timer);
      if (current && current !== item) setOpen(current, false);
      current = item;
      setOpen(item, true);
    }
    function close(item) {
      if (!item) return;
      setOpen(item, false);
      if (current === item) current = null;
    }
    function closeLater(item) {
      clearTimeout(timer);
      timer = setTimeout(function () { close(item); }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var a = item.querySelector(':scope > .ae-mm__top');
      item.addEventListener('pointerenter', function () { eager(item); });
      item.addEventListener('mouseenter', function () { open(item); });
      item.addEventListener('mouseleave', function () { closeLater(item); });
      item.addEventListener('focusin', function () { eager(item); open(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeLater(item);
      });
      /* Touch op een desktopbreed scherm: eerste tik opent, tweede tik volgt de link */
      a.addEventListener('touchstart', function () { a.__aeTouch = true; }, { passive: true });
      a.addEventListener('click', function (e) {
        if (a.__aeTouch && !item.classList.contains('is-open')) {
          e.preventDefault();
          open(item);
        }
        a.__aeTouch = false;
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        var a = current.querySelector(':scope > .ae-mm__top');
        close(current);
        if (a) a.focus();
      }
    });
    document.addEventListener('touchstart', function (e) {
      if (current && !current.contains(e.target)) close(current);
    }, { passive: true });
  }

  function initTabs(scope) {
    scope.querySelectorAll('[data-ae-tabs]').forEach(function (tabs) {
      var links = tabs.querySelector(':scope > .ae-tabs__links');
      var panels = tabs.querySelector(':scope > .ae-tabs__contents');
      if (!links || !panels) return;
      var lis = Array.prototype.slice.call(links.children);
      var ps = Array.prototype.slice.call(panels.children);
      function activate(i) {
        lis.forEach(function (li, j) { li.classList.toggle('is-active', j === i); });
        ps.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      }
      lis.forEach(function (li, i) {
        li.addEventListener('mouseenter', function () { activate(i); });
        li.addEventListener('focusin', function () { activate(i); });
      });
    });
  }

  function initCarousels(scope) {
    scope.querySelectorAll('[data-ae-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-ae-track]');
      if (!track) return;
      function step() {
        var first = track.children[0];
        if (!first) return 0;
        return first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 24);
      }
      function go(dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        var x = track.scrollLeft + dir * step();
        if (dir > 0 && track.scrollLeft >= max) x = 0;
        if (dir < 0 && track.scrollLeft <= 2) x = track.scrollWidth;
        track.scrollTo({ left: x, behavior: 'smooth' });
      }
      var prev = c.querySelector('[data-ae-prev]');
      var next = c.querySelector('[data-ae-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
    });
  }


  /* ===== Mobiele menulade: submenu's schuiven in, opgebouwd uit het desktop-menu ===== */
  function initMobile(ul) {
    if (ul.__aeInit) return;
    ul.__aeInit = true;
    var stack = [];
    var chevLeft = '<svg viewBox="0 0 640 1792" aria-hidden="true" focusable="false"><path transform="matrix(1 0 0 -1 0 1536)" d="M627 992q0 -13 -10 -23l-393 -393l393 -393q10 -10 10 -23t-10 -23l-50 -50q-10 -10 -23 -10t-23 10l-466 466q-10 10 -10 23t10 23l466 466q10 10 23 10t23 -10l50 -50q10 -10 10 -23z"/></svg>';

    function scrollDrawerTop() {
      var inner = ul.closest('.drawer__inner');
      if (inner && inner.scrollTop > 0) inner.scrollTop = 0;
    }
    function stripIds(node) {
      if (node.removeAttribute) node.removeAttribute('id');
      node.querySelectorAll && node.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      node.querySelectorAll && node.querySelectorAll('[aria-controls]').forEach(function (n) { n.removeAttribute('aria-controls'); });
    }
    function bindTabs(layer) {
      layer.querySelectorAll('.ae-tabs__item').forEach(function (li) {
        var a = li.querySelector(':scope > .ae-tabs__link');
        if (!a || !a.hasAttribute('aria-haspopup')) return;
        var tabs = li.closest('.ae-tabs');
        var idx = li.getAttribute('data-ae-tab');
        var panel = tabs && tabs.querySelector(':scope > .ae-tabs__contents > [data-ae-panel="' + idx + '"]');
        if (!panel) return;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var title = (li.querySelector('.ae-tabs__text') || a).textContent.trim();
          var nodes = Array.prototype.slice.call(panel.children);
          var icon = a.querySelector('.ae-mm__icon, .ae-mm__symwrap');
          push(title, nodes.map(function (n) { return n.cloneNode(true); }), null, icon ? icon.cloneNode(true) : null, e.detail === 0);
        });
      });
    }
    /* kb = geopend met het toetsenbord (click zonder aanraking/muis, e.detail 0).
       Alleen dan verplaatsen we de focus; bij aantikken niet, anders tekent de browser een (blauwe) focusrand. */
    function push(title, nodes, opener, icon, kb) {
      var layer = document.createElement('div');
      layer.className = 'ae-mmm__layer';
      layer.setAttribute('role', 'region');
      layer.setAttribute('aria-label', title);
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'ae-mmm__head';
      head.innerHTML = chevLeft;
      if (icon) { icon.classList.add('ae-mmm__hicon'); head.appendChild(icon); }
      var label = document.createElement('span');
      label.textContent = title;
      head.appendChild(label);
      head.setAttribute('aria-label', 'Terug: ' + title);
      head.addEventListener('click', function (e) { pop(e.detail === 0); });
      layer.appendChild(head);
      nodes.forEach(function (n) { stripIds(n); layer.appendChild(n); });
      eager(layer);
      bindTabs(layer);
      initCarousels(layer);
      ul.appendChild(layer);
      stack.push({ layer: layer, opener: opener });
      ul.classList.add('is-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      scrollDrawerTop();
      requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-in'); if (kb) head.focus({ preventScroll: true }); }); });
    }
    function pop(kb) {
      var top = stack.pop();
      if (!top) return;
      top.layer.classList.remove('is-in');
      if (top.opener) { top.opener.setAttribute('aria-expanded', 'false'); if (kb) top.opener.focus({ preventScroll: true }); }
      setTimeout(function () { top.layer.remove(); }, 260);
      if (!stack.length) ul.classList.remove('is-open');
      else if (kb) stack[stack.length - 1].layer.querySelector('.ae-mmm__head').focus({ preventScroll: true });
    }
    ul.querySelectorAll('[data-ae-src]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var src = document.getElementById(a.getAttribute('data-ae-src'));
        if (!src) return; /* geen desktop-menu gevonden: gewoon de link volgen */
        e.preventDefault();
        var title = (a.querySelector('.ae-mmm__label') || a).childNodes[0].textContent.trim();
        var nodes = Array.prototype.slice.call(src.children).map(function (n) { return n.cloneNode(true); });
        push(title, nodes, a, null, e.detail === 0);
      });
    });
  }
  window.AeMobileMenu = function () {
    document.querySelectorAll('[data-ae-mmm]').forEach(initMobile);
  };

  function init() {
    document.querySelectorAll('[data-ae-mm]').forEach(function (root) {
      if (root.__aeInit) return;
      root.__aeInit = true;
      initDesktop(root);
      initTabs(root);
      initCarousels(root);
    });
    if (window.AeMobileMenu) window.AeMobileMenu();
    document.querySelectorAll('.header__deals-item').forEach(function (li) {
      li.addEventListener('pointerenter', function () { eager(li); });
      li.addEventListener('focusin', function () { eager(li); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
